export const TEXTS = {
  hero_eyebrow: "Cafetería de Tradición",
  hero_l1: "Una *sinfonía*",
  hero_l2: "de sabor con un",
  hero_l3: "toque *alemán.*",
  hero_sub: "Somos una empresa Queretana de ascendencia alemana. Contamos con una amplia línea de productos de elaboración propia preparados bajo los más altos estándares de calidad. Ofrecemos cocina internacional, mexicana y especialidades alemanas en cocina y repostería.",
  hero_frame: "Hecho en casa, desde el primer día.",
  hero_photo: "/img/portada.webp",
  nos_eyebrow: "Herzlich Willkommen · Nuestra historia",
  nos_title: "Una tradición queretana con más de *40 años* de calidad y servicio.",
  nos_year: "1986",
  nos_year_text: "5 de diciembre — primera sucursal en el emblemático acueducto de Querétaro, fundada por Martina Neumann, originaria de Werdohl, Alemania.",
  pil_eyebrow: "Bienvenido",
  pil_title: "Tenemos lo que *buscas*",
  pil_sub: "Tres mundos bajo un mismo techo: cocina, repostería y una tienda llena de detalles.",
  menu_eyebrow: "Menú Restaurante",
  menu_title: "Nuestras *especialidades*",
  menu_de: "Unsere Spezialitäten",
  sug_eyebrow: "— Sugerencias de la casa —",
  sug_title: "Desayuno, comida o cena.",
  mc_eyebrow: "Speisekarte",
  mc_title: "Menú *completo*",
  mc_de: "Desayuno, comida o cena — a cualquier hora del día",
  pas_eyebrow: "Konditorei",
  pas_title: "Nuestros *pasteles*",
  pas_de: "Repostería alemana de línea y especial",
  pas_sub: "Pasa el cursor —o toca— cada pastel para descubrirlo. Recetas de familia, elaboración propia.",
  ev_title: "Pasteles decorados",
  prod_eyebrow: "Aus unserer Backstube",
  prod_title: "Otros *productos*",
  prod_de: "Weitere Produkte",
  prod_sub: "También los puedes llevar a casa desde nuestra tienda.",
  btn_prod_wa: "Pregunta por disponibilidad",
  wa_msg_prod: "Hola Café Amadeus, me gustaría saber la disponibilidad de {producto}.",
  reu_eyebrow: "Für Meetings",
  reu_title: "Para tus eventos *contamos con*",
  gal_eyebrow: "Tienda de Regalos",
  gal_title: "Tienda de *Regalos*",
  gal_de: "Unser Laden",
  dec_eyebrow: "Pasteles Decorados",
  dec_title: "Pasteles *Decorados*",
  dec_de: "Dekorierte Torten",
  dec_intro_title: "Hacemos de cada pastel algo especial.",
  dec_intro: "Personaliza tu pastel con decoraciones en crema, fondant e impresiones comestibles para celebrar tus momentos más especiales.",
  eco_photo: "/img/reforestacion2.jpg",
  eco_eyebrow: "En Café Amadeus",
  eco_title: "Comprometidos con el medio ambiente y la sociedad.",
  eco_text: "Trabajamos directamente con la fundación Ayudando.mx, A.C., apoyándolos en la alimentación diaria de personas de bajos recursos.",
  eco_cta: "¡Los invitamos a ser parte del cambio!",
  suc_eyebrow: "Visítanos",
  suc_title: "Nuestras *sucursales*",
  suc_de: "Unsere Filialen",
  foot_cta: "¿Nos tomamos *un café?*",
  foot_about: "Café y Pastelería Amadeus. Empresa 100% Queretana de ascendencia alemana, desde 1986.",
  btn_nav_wa: "Escríbenos",
  btn_hero_menu: "Explora el menú",
  btn_hero_pas: "Pastelería",
  btn_hero_wa: "WhatsApp",
  btn_menu_full: "Ver menú completo",
  btn_menu_wa: "Pregunta por WhatsApp",
  btn_pas_wa: "Cotiza tu pastel personalizado",
  btn_pas_catalog: "Catálogo de Pasteles",
  pas_catalog_img: "/img/catalogo-pasteles-qr.jpg",
  btn_reu_wa: "Cotizar por WhatsApp",
  btn_suc_map: "Cómo llegar",
  btn_suc_wa: "WhatsApp",
  btn_foot_wa: "Escríbenos por WhatsApp",
  btn_bubble: "En ocasiones nuestra línea fija está saturada, si tienes alguna duda, déjanos un WhatsApp. *Solo suc. Arcos*",
  wa_number: "52 442 258 1218",
  wa_msg_default: "Hola Café Amadeus, me gustaría más información.",
  wa_msg_menu: "Hola Café Amadeus, tengo una pregunta sobre el menú.",
  wa_msg_pas: "Hola Café Amadeus, me gustaría cotizar un pastel personalizado para un evento.",
  wa_msg_reu: "Hola Café Amadeus, me gustaría cotizar canapés / box lunch / coffee break para una reunión.",
  wa_msg_suc: "Hola Café Amadeus {sucursal}, tengo una duda.",
};

export const FONT_OPTIONS = {
  display: ["Cormorant Garamond", "Playfair Display", "Bodoni Moda", "Fraunces", "Libre Caslon Display", "Italiana", "Marcellus", "Cinzel"],
  body: ["Manrope", "Jost", "Lora", "Karla", "Outfit", "Nunito Sans", "Work Sans", "Libre Franklin"],
};

export const SETTINGS = { fontDisplay: "Cormorant Garamond", fontBody: "Manrope" };
